export default __webpack_public_path__ + "static/media/profile-cover.a4c482be.png";